import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useI18n } from '../../../../../i18n';
import { ReduxKeyContext } from '../../../../misc/ReduxKeyContext';
import * as widgets from '../../../../redux/app/widgets';
import List from '../../../general/list/List';
import ListItem from '../../../general/list/ListItem';
import { WidgetType } from '../../../general/widgets/widgetRegistry';
import ActionClose from '../../../share/actionbar/ActionClose';

/**
 * @param {Object} props
 * @param {function} props.onCancel
 * @param {React.RefObject} props.customRef
 */

function DashboardWidgetSelector(props) {
	const { f } = useI18n();
	const reduxKey = useContext(ReduxKeyContext);
	const dispatch = useDispatch();

	const addWidget = (type) => {
		dispatch(widgets.actions.add({ domain: reduxKey, widgetType: type }));
	}

	const items = {
		[f('commuters')]: WidgetType.Commuters,
		[f('device info')]: WidgetType.DeviceInfo,
		[f('runway info')]: WidgetType.RunwayInfo,
		[f('runway statuses')]: WidgetType.RunwayStatuses,
		[f('taxiway incidents')]: WidgetType.TaxiwayIncidents,
		[f('device presence detector')]: WidgetType.DevicePresenceDetector,
		[f('attribute range detector')]: WidgetType.AttributeRangeDetector,
		[f('trips')]: WidgetType.Trips,
		[f('events')]: WidgetType.Events,
		[f('device tracking')]: WidgetType.DeviceTrackingWidget
	};

	return (
		<div className="widget-selector dashboard" ref={props.customRef}>
			<div className="header">
				<div className="title">
					{f('widgets')}
				</div>
				<ActionClose onClick={props.onCancel} />
			</div>
			<List>
				{Object.keys(items).sort().map(key =>
					<ListItem key={key} onClick={() => addWidget(items[key])}>{key}</ListItem>
				)}
			</List>
		</div>
	);
}

export default DashboardWidgetSelector;
